export const prepareLabel = (label = '') =>
  label.replace(/([a-z])([A-Z])/g, '$1 $2');
